'use client';

import { cn, TLoadingSpinnerProps } from 'types';

export const LoadingSpinner = (props: Partial<TLoadingSpinnerProps>) => {
  const { color = 'var(--color-black)', size = 48, isModal = false, className = '' } = props;

  const spinner = (
    <div
      className={cn('relative inline-block [animation-timing-function:cubic-bezier(0,1,1,0)]', className)}
      aria-label="loading"
      style={{
        width: Math.max(size, 48),
        height: Math.max(size, 20),
        ...({ ['--spinner-color']: String(color) } as React.CSSProperties & Record<string, string>),
      }}
    >
      <div className="absolute left-1 top-[calc(50%-4px)] w-2 h-2 rounded-full [animation:spinner-ellipsis-scale-in_700ms_infinite] bg-[var(--spinner-color)]" />
      <div className="absolute left-1 top-[calc(50%-4px)] w-2 h-2 rounded-full [animation:spinner-ellipsis-move_700ms_infinite] bg-[var(--spinner-color)]" />
      <div className="absolute left-5 top-[calc(50%-4px)] w-2 h-2 rounded-full [animation:spinner-ellipsis-move_700ms_infinite] bg-[var(--spinner-color)]" />
      <div className="absolute left-9 top-[calc(50%-4px)] w-2 h-2 rounded-full [animation:spinner-ellipsis-scale-out_700ms_infinite] bg-[var(--spinner-color)]" />
    </div>
  );

  if (!isModal) return spinner;

  return (
    <div className={cn('fixed inset-0 z-3 flex h-full w-full items-center justify-center bg-pureWhite/60', className)}>
      {spinner}
    </div>
  );
};
